import UILayout from "components/layout/UILayout";
import UILabel from "components/ui/UILabel";
import { Link } from "react-router-dom";
import styled from "styled-components";

export const Wrapper = styled(UILayout)`
  display: flex;
  flex-direction: column;
  gap: 36px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Divider = styled.hr`
  width: 100%;
  border: none;
  border-top: 1px solid ${(props) => props.theme.colors.primary}40;
  margin: 12px 0;
`;

export const AccountList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const AccountLink = styled(Link)`
  color: inherit;

  text-decoration: none;
`;

export const LineItems = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0;
  margin: 0;

  list-style: none;
`;

export const LineItemText = styled(UILabel.Medium)``;

export const LineItemValue = styled(LineItemText).attrs(() => ({
  bold: true,
  color: "primary",
}))``;

export const LineItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
